import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=1699c138&scoped=true"
import script from "./sideBar.vue?vue&type=script&lang=ts"
export * from "./sideBar.vue?vue&type=script&lang=ts"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=1699c138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1699c138",
  null
  
)

export default component.exports